<!--  -->
<template>
<transition name="el-fade-in-linear">
<div class='' v-show="show" style="height:90%">
<el-button style="margin-bottom:10px" type="success" icon="el-icon-plus" @click="dialogFormInsertVisible=true" plain>添加地区</el-button>
 <el-table
        v-loading="loading"
        :data="tableData.list"
        style="width: 100%;height:85%;overflow: scroll;">
        <el-table-column
           prop="areaName"
          label="地区"
          width="180">
        </el-table-column>
        <el-table-column
           prop="areaCoordinate"
          label="坐标"
          width="180">
        </el-table-column>
        <el-table-column
          prop="num"
          label="门店数"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="ifshow"
          label="是否展示"
          :filters="[{text:'展示',value:true},{text:'未展示',value:false}]"
          :filter-method="filterIfshow"
          width="180">
          <template slot-scope="scope">
             <el-switch
              :value="scope.row.ifshow"
              @change="changeDisplay(scope.$index)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发布时间"
          sortable
          width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              style="margin-right:10px"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="handleAreaDelete(scope.$index, scope.row)"
                title="确定删除吗？"
              >
                <el-button
                size="mini"
                type="danger"
                slot="reference">删除</el-button>
              </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:10px"
        layout="prev, pager, next"
        @current-change="handleAreaCurrentChange"
        :total="tableData.totalCount"
        :page-size="tableData.pageSize">
      </el-pagination>
      <el-dialog title="添加地区" :visible.sync="dialogFormInsertVisible" width="25%">
        <el-form ref="insertForm" :model="areaInsertForm" :rules="insertRules">
          <el-form-item label="区域名称" label-width="120px" prop="areaName">
           <el-input v-model="areaInsertForm.areaName" clearable></el-input>
          </el-form-item>
          <el-form-item label="区域经度" label-width="120px" prop="x">
           <el-input v-model="areaInsertForm.x" clearable></el-input>
          </el-form-item>
          <el-form-item label="区域维度" label-width="120px" prop="y">
           <el-input v-model="areaInsertForm.y" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormInsertVisible = false">取 消</el-button>
          <el-button type="primary" @click="addArea('insertForm')">添加</el-button>
        </div>
      </el-dialog>
      <el-dialog  title="编辑" :visible.sync="dialogFormEditVisible" width="40%">
        <el-form ref="editForm" :rules="updateRules" :model="areaEditForm">
          <el-form-item label="区域id" label-width="120px" prop="areaName" v-show="false">
           <el-input v-model="areaEditForm.id" clearable></el-input>
          </el-form-item>
          <el-form-item label="区域名称" label-width="120px" prop="areaName">
           <el-input v-model="areaEditForm.areaName" clearable></el-input>
          </el-form-item>
          <el-form-item label="区域坐标" label-width="120px" prop="areaName">
           <el-input v-model="areaEditForm.areaCoordinate" clearable></el-input>
          </el-form-item>
          <el-form-item label="地区门店" label-width="120px">
            <div style="display:flex;justify-content:space-around">
            <el-input placeholder="请输入名称" v-model="shop.shopName" clearable></el-input>
            <el-input placeholder="请输入地址" v-model="shop.shopAddress" clearable></el-input>
            <el-button type="success" icon="el-icon-plus" @click="addShop()" circle></el-button>
            </div>
            <div style="color:red;font-size: 13px;">双击选项可进行编辑修改</div>
            <el-table
              :data="areaEditForm.shops.list"
              :style="areaEditForm.shops.totalCount>4?'width: 100%;height:277px':'width: 100%'">
              <el-table-column
                prop="shopName"
                label="名称"
                width="200">
                <template slot-scope="scope">
                  <div @dblclick="editShop(scope.row,'shopName')">
                    <el-input v-focus @blur="exitShopEdit(scope.row)"  v-if="shopEdit.ifEditName&&shopEdit.id===scope.row.id" v-model="shopEdit.shopName"></el-input>
                    <div v-else>{{scope.row.shopName==""?"无数据":scope.row.shopName}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="shopAddress"
                label="地址"
                width="300">
                <template slot-scope="scope">
                  <div @dblclick="editShop(scope.row,'shopAddress')">
                    <el-input v-focus @blur="exitShopEdit(scope.row)"  v-if="shopEdit.ifEditAddress&&shopEdit.id===scope.row.id" v-model="shopEdit.shopAddress"></el-input>
                    <div v-else>{{scope.row.shopAddress==""?'无数据':scope.row.shopAddress}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                 <template slot-scope="scope">
                  <el-button
                  size="mini"
                  type="danger"
                  @click="handleShopDelete(scope.$index, scope.row)">删除</el-button>
                 </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              style="margin-top:10px"
              layout="prev, pager, next"
              v-if="areaEditForm.shops.totalCount>4"
              @current-change="handleShopCurrentChange"
              :total="areaEditForm.shops.totalCount"
              :page-size="areaEditForm.shops.pageSize">
            </el-pagination>
        </el-form-item>
          <el-form-item label="是否展示" label-width="120px">
            <el-switch
              v-model="areaEditForm.ifshow"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormEditVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateAreaData('editForm')">更新</el-button>
        </div>
      </el-dialog>
</div>
</transition>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {insert,queryAreaList,update,queryArea,queryShopList,deleted} from '@/api/admin/companyDistribution.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
 show:false,
 loading:true,
 dialogFormEditVisible:false,
 dialogFormInsertVisible:false,
 shopEdit:{
   id:"",
   ifEditName:false,
   ifEditAddress:false,
   shopName:"",
   shopAddress:""
 },
 condition:{
  current:1,
  size:12,
  title:""
 },
 shop:{
  shopName:"",
  shopAddress:"",
  pid:""
 },
 updateRules:{
  areaName:{required:true,message:"区域名称不能为空",trigger:'blur'},
  areaAddress:{required:true,message:"区域地址不能为空",trigger:'blur'}
 },
 insertRules:{
  areaName:{required:true,message:"区域名称不能为空",trigger:'blur'},
  x:{required:true,message:"区域经度不能为空",trigger:'blur'},
  y:{required:true,message:"区域维度不能为空",trigger:'blur'}
},
 areas:[
    {
      name:"北京",
      coordinate:"116.4551, 40.2539"
    },
    {
      name:"河北",
      coordinate:"115.4004, 38.1688"
    }
  ],
  areaInsertForm:{
    areaName:"",
    areaCoordinate:"",
    x:"",
    y:""
  },
 areaEditForm:{
  id:"",
  areaName:"",
  areaCoordinate:"",
  shops:{
    list:[]
  },
  ifshow:false
 },
 tableData:{
  totalCount:1,
  pageSize:1,
  totalPage:1,
  currPage:1,
  list:[
     {
    areaName:"",
    areaCoordinate:"",
    num:"",
    createTime:"",
    store:[
      {
        name:"111",
        address:"1111111111111111111111111111111111111111111111111111111111"
      }
    ],
    ifshow:false
    }
  ]
 }
};
},
//监听属性 类似于data概念
computed: {},
directives:{
// 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted(el) {
        // 聚焦元素
        if (el.querySelector('input')) {
          el.querySelector('input').focus();
        }
      },
    },
},
//监控data中的数据变化
watch: {
  areaInsertForm:{
    deep:true,
    handler(newD){
      this.areaInsertForm.areaCoordinate=newD.x+","+newD.y
    }
  },
  areaEditForm:{
    deep:true,
    handler(newD){
      this.shop.pid=newD.id
    }
  }
},
//方法集合
methods: {
  filterIfshow(value, row){
     return row.ifshow === value;
  },
  handleShopDelete(index){
    var _this = this
    deleted(_this.areaEditForm.shops.list[index]).then(()=>{
      if((_this.areaEditForm.shops.totalCount%4==1)&&_this.areaEditForm.shops.totalCount!=1&&_this.areaEditForm.shops.currPage==_this.areaEditForm.shops.totalPage){
        _this.areaEditForm.shops.currPage=_this.areaEditForm.shops.currPage-1
      }
       _this.$message.success("删除成功!")
      queryShopList({pid:_this.shop.pid,current:_this.areaEditForm.shops.currPage,size:4}).then(({data})=>{
        _this.areaEditForm.shops=data
      },()=>{_this.areaEditForm.shops.list=[]})
    })
  },
  handleAreaDelete(index){
    var _this = this
    deleted(_this.tableData.list[index]).then(()=>{
      if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
        _this.condition.current=_this.condition.current-1
      }
      _this.$message.success("删除成功!")
      queryAreaList(_this.condition).then(({data})=>{
        _this.tableData=data
      },()=>{_this.tableData.list=[]})
    })
  },
  updateAreaData(name){
    var _this = this
     this.$refs[name].validate((valid)=>{
      if(valid){
        update(_this.areaEditForm).then(()=>{
          _this.$message.success("修改成功")
          queryAreaList(_this.condition).then(({data})=>{
            _this.tableData=data
          })
          _this.dialogFormEditVisible=false
        })
      }else{
        _this.$message.info("有必填项为空,请检查后再次提交")
      }
     })
  },
  exitShopEdit(row){
    var _this = this
    this.shopEdit.ifEditName=false
    this.shopEdit.ifEditAddress=false
    if(row.shopName==_this.shopEdit.shopName&&row.shopAddress==_this.shopEdit.shopAddress){//没有改动就不用更新
      return;
    }
    update(_this.shopEdit).then(()=>{
      queryShopList({pid:_this.shop.pid,current:_this.areaEditForm.shops.currPage,size:4}).then(({data})=>{
        _this.areaEditForm.shops=data
        _this.$message.success("修改成功")
      })
    })
  },
  editShop(row,name){
    this.shopEdit.id=row.id
    this.shopEdit.shopName=row.shopName
    this.shopEdit.shopAddress=row.shopAddress
    if(name=='shopName'){
     this.shopEdit.ifEditName=true
    }else{
     this.shopEdit.ifEditAddress=true
    }

  },
  handleShopCurrentChange(val){
    var _this = this
    queryShopList({pid:_this.shop.pid,current:val,size:4}).then(({data})=>{
      _this.areaEditForm.shops=data
    })
  },
  handleAreaCurrentChange(val){
      var _this =this
      _this.condition.current = val
      queryAreaList(_this.condition).then(({data})=>{
      _this.tableData=data
    })
  },
  addShop(){
    var _this = this
    insert(_this.shop).then(()=>{
      queryShopList({pid:_this.shop.pid,current:0,size:4}).then(({data})=>{
        _this.areaEditForm.shops=data
        _this.$message.success("添加店铺成功!")
      })
    })
  },
  changeDisplay(index){
    var _this = this
    update({id:_this.tableData.list[index].id,ifshow:!_this.tableData.list[index].ifshow}).then(({code})=>{
      if(code==200){
        _this.$message.success("更新成功!")
      }
    })
    this.tableData.list[index].ifshow=!this.tableData.list[index].ifshow
  },
  addArea(name){
   var _this =this
   this.$refs[name].validate((valid)=>{
    if(valid){
       insert(_this.areaInsertForm).then(()=>{
        _this.$message.success("添加成功")
        _this.dialogFormInsertVisible=false
        _this.areaInsertForm={
            areaName:"",
            areaCoordinate:"",
            x:"",
            y:""
          }
          queryAreaList(_this.condition).then(({data})=>{
            _this.tableData=data
          })
       })
    }else{
      _this.$message.info("请填写完整信息")
    }
   })
  },
  handleEdit(index, row){
    var _this = this
    this.dialogFormEditVisible=true
    queryArea({id:row.id,current:1,size:4}).then(({data})=>{
      _this.areaEditForm=data
    })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 var _this =this
 this.show=true
 queryAreaList(_this.condition).then(({data})=>{
  _this.tableData=data
  _this.loading=false
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类

</style>